// extracted by mini-css-extract-plugin
module.exports = {"calendario":"Calendario_calendario__1Rb4l","titulo":"Calendario_titulo__zBEun","tabelaDesktop":"Calendario_tabelaDesktop__WARxM"};